module.exports = __webpack_public_path__ + "mustache.svg?6204638ad49cbef1fdd20996ee996999";